import {jsx} from 'panel';
import {VNode} from 'snabbdom';

import {ControlBarEl} from 'common/widgets/control-bar';
import {ButtonEl} from 'common/components/button';
import {ButtonTheme, ButtonType} from 'common/components/button/constants';
import {Placement} from 'common/components/tooltip/types';
import {Section, SectionItem} from 'common/components/items-menu/types';
import {ContextPanelData} from 'common/widgets/context-panel/types';

import {Action} from '../types';
import {ControlBarAction, ControlBarActionValue} from '../constants';

export function RowActions({
  actionsRenderer = null,
  canDeleteEntry,
  disabled,
  hasBehavioralFrequencyFilter,
  hasNewUI,
  index,
  isEmptyPlaceholder,
  onEventActionClick,
  onControlSelect,
  overflowControls,
  overflowControlsContextPanelTransform,
}: {
  actionsRenderer?: () => VNode | null;
  canDeleteEntry: boolean;
  disabled: boolean;
  hasBehavioralFrequencyFilter: boolean;
  hasNewUI: boolean;
  index: number;
  isEmptyPlaceholder: boolean;
  onEventActionClick: (action: Action, index: number) => void;
  onControlSelect: (value: ControlBarActionValue, index: number) => void;
  overflowControls: Array<Section<ControlBarActionValue>>;
  overflowControlsContextPanelTransform: (item: SectionItem) => ContextPanelData;
}) {
  const controls = overflowControls.map((section) => section.items).flat();
  const isDeleteOnly = controls.length === 1 && controls[0].value?.action === ControlBarAction.Delete;
  const showOverflowMenu = controls.length > 0 && !isDeleteOnly;

  const deleteButton = (
    <ButtonEl
      key='entry-delete-action'
      attrs={{
        elref: `deleteLineButton`,
        theme: ButtonTheme.Tertiary,
        icon: hasNewUI ? `x` : `trashcan`,
        role: `button`,
        disabled,
        type: ButtonType.Destructive,
        tooltip: {
          text: `Remove`,
          placement: Placement.Top,
        },
      }}
      on={{
        click: () => onEventActionClick(Action.Remove, index),
      }}
    />
  );

  return (
    <div sel='.mp-query-entry-actions'>
      {actionsRenderer && actionsRenderer()}

      {/** row delete button */}
      {canDeleteEntry && !hasBehavioralFrequencyFilter && hasNewUI && !isEmptyPlaceholder && deleteButton}

      {!hasBehavioralFrequencyFilter && (
        <div sel='.mp-query-control-bar-container'>
          {showOverflowMenu && (
            <ControlBarEl
              key='entry-actions'
              attrs={{
                elref: `lineActions`,
                theme: ButtonTheme.Tertiary,
                'overflow-icon': hasNewUI ? `ellipsis` : `hor-ellipsis`,
                'overflow-controls': overflowControls,
                'overflow-menu-width': 200,
                'overflow-menu-height': 330,
                disabled,
              }}
              on={{
                select: (ev: CustomEvent) => onControlSelect(ev.detail.value, index),
              }}
              props={{
                contextPanelTransform: overflowControlsContextPanelTransform,
              }}
            />
          )}
        </div>
      )}

      {/** row delete button */}
      {canDeleteEntry && !hasBehavioralFrequencyFilter && !hasNewUI && !isEmptyPlaceholder && deleteButton}
    </div>
  );
}
